import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-blue-900 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1nbbzzw4fnuo7">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-166" data-mp="1ncmzvkurcia1">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-slate-300/40 bg-blue-950 shadow-2xl shadow-black/40" data-id="element-167" data-mp="1x8gnbza0lw6l">
          <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-168" data-mp="227b4kwsc3col" />
          <div className="p-6 sm:p-10" data-id="element-169" data-mp="2vgwfa06pfk0">
            <span className="metal-silver inline-flex items-center gap-2 rounded-full border border-slate-400 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-blue-950" data-id="element-170" data-mp="2ws3pjsu95fv">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="1mhzjje2y8nd1" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-slate-300/20 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-172" data-mp="1hon702bjo70n">
              <div data-id="element-173" data-mp="17s201bfyslu6">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-174" data-mp="17sjtk0b8slye">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-300" data-id="element-175" data-mp="25fsi646jib4m">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-176" data-mp="1vg1pm81ji676">
                <span className="text-sm text-slate-400" data-id="element-177" data-mp="1vj7cdgmp4vzq">
                  Regular price <span className="line-through" data-id="element-178" data-mp="1rfhu18wm7an5">{priceBefore}</span>
                </span>
                <p className="metal-silver-text mt-1 text-5xl font-extrabold" data-id="element-179" data-mp="k3r48mp4lccr">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-slate-300" data-id="element-180" data-mp="fzt7gin9wdmv">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-181" data-mp="mgkxe0fdveb6">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-slate-100" data-id="element-182" data-mp="7ju4ma07t0uj">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-183" data-mp="ci5fmo28xhec" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-184" data-mp="3i07gbp8aez4">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-185" data-mp="3l0bbr9ev4r5a">
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="3pv8ha6cxoidf">
                <LockIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-187" data-mp="3bybtkds43h0r" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-188" data-mp="3g1hwpcjxgs30">
                <ZapIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-189" data-mp="2xbwcnegks8q1" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-190" data-mp="2sdl5jbho0cbi">
                <ShieldCheckIcon className="h-4 w-4 text-slate-300" aria-hidden="true" data-id="element-191" data-mp="36c1i3j27kx1k" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-slate-400" data-id="element-192" data-mp="31bdlmhv7nnzy">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}